module.exports = __webpack_public_path__ + "static/img/fa.9c0fd3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fa.png
// module id = gbeC
// module chunks = 1